import { Link } from "react-router-dom";
import { Layout, Button } from "rhombus-react";
import React from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { getFormValues, isInvalid, isSubmitting } from "redux-form";
import { QR_DESIGN_DETAILS } from "forms/list";

export const QrCodesDesignFormFooter = (props) => {
	const { libraryId } = useParams();
	const { readonly } = props;
	const qrDesignFormData = useSelector(getFormValues(QR_DESIGN_DETAILS)) || {};
	const formIsInvalid = useSelector(isInvalid(QR_DESIGN_DETAILS));
	const formIsSubmitting = useSelector(isSubmitting(QR_DESIGN_DETAILS));

	const qrCodesState = useSelector(state => state.qrDesigns);
	return (
		<Layout.ModalFooter className={"qr-codes-design-footer"}>
			<Link to={`/library/${libraryId}/qr-designs`} data-testid={"back-link"}>
				<Button theme="grey">
					{readonly ? "Back" : "Cancel"}
				</Button>
			</Link>
			{!readonly && !!qrCodesState.design
				&& <Button
					type="submit"
					theme="green"
					disabled={formIsInvalid || formIsSubmitting}
				>
					{`${qrDesignFormData.isEdition ? "Edit" : "Create"} QR Code Design`}
				</Button>
			}
		</Layout.ModalFooter>
	);
};
